import { useState, useEffect } from 'react';

function useClipboard() {
  const [clipboardContent, setClipboardContent] = useState('');

  // Function to read clipboard content
  const readClipboard = async () => {
    try {
      const text = await navigator.clipboard.readText();
      setClipboardContent(text);
    } catch (error) {
      console.error('Error reading clipboard:', error);
    }
  };

  // Function to write text to clipboard
  const writeClipboard = async (textToCopy) => {
    try {
      await navigator.clipboard.writeText(textToCopy);
      setClipboardContent(textToCopy);
    } catch (error) {
      console.error('Error writing to clipboard:', error);
    }
  };

  // Listen for clipboard changes when the component mounts
  useEffect(() => {
    const clipboardChangeHandler = () => {
      readClipboard();
    };

    document.addEventListener('clipboard-read', clipboardChangeHandler);

    // Clean up the event listener when the component unmounts
    return () => {
      document.removeEventListener('clipboard-read', clipboardChangeHandler);
    };
  }, []);

  return {
    clipboardContent,
    readClipboard,
    writeClipboard,
  };
}

export default useClipboard;
